var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog[data-v-23da1903],.dialog__content[data-v-23da1903]{position:fixed!important;bottom:1%!important;right:1%!important;left:auto!important;top:auto!important;width:auto}.no-webp #demoHolder[data-v-23da1903]{background:url(" + escape(require("../../assets/images/backgrounds/white.jpg")) + ") 50%}.no-webp #demoHolder[data-v-23da1903],.webp #demoHolder[data-v-23da1903]{max-width:290px;max-height:90%;overflow:auto;position:fixed;bottom:1%;right:55px;border-radius:0;border:1px solid #000;z-index:1001}.webp #demoHolder[data-v-23da1903]{background:url(" + escape(require("../../assets/images/backgrounds/white.webp")) + ") 50%}", ""]);

// exports
